<template>
  <div v-if="inspection" class="h-100 overflow-auto">
    <report-viewer
      v-for="pole in inspection.poles"
      :key="pole._id"
      :source="inspection.source"
      :pole="pole"
      :filters="filters"
      :voltage="inspection.voltage"
      :load="inspection.load"
      :humidity="inspection.humidity"
      :temperature="inspection.temperature"
    />
  </div>
</template>

<script>
import API from "@/api";
import ReportViewer from "@/components/ReportViewer";

export default {
  name: "print",
  components: {
    "report-viewer": ReportViewer,
  },
  data() {
    return {
      inspection: null,
    };
  },
  watch: {
    $route: {
      async handler() {
        if (this.$route.query) {
          let inspection = this.$route.query.inspection;
          let filters = {
            print: true,
          };
          Object.keys(this.$route.query).forEach((key) => {
            if (key.includes("filter_")) {
              filters[`${key.replace("filter_", "")}`] = this.$route.query[key];
            }
          });
          this.filters = filters;
          if (inspection) {
            await this.getPoleReports(inspection, filters);
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async getPoleReports(inspection, filters) {
      let url = `report/${inspection}?`;
      Object.keys(filters).forEach((key) => {
        let filter = filters[key];
        url += `${key}=${filter}&`;
      });
      url = url.slice(0, -1);
      API.get(url)
        .then((retVal) => {
          this.inspection = retVal.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
